module.exports = function init_wistia() {

  // video overlay to allow for cursor:pointer on video thumb with other controls / user feedback removed
  if(document.querySelector('.video-overlay')) {
    document.querySelector('.video-overlay').addEventListener('click', function() {
      const wistiaPlayer = document.querySelector('wistia-player');
      if (wistiaPlayer) {
        if(wistiaPlayer.state == 'playing') {
          wistiaPlayer.pause();
        } else {
          wistiaPlayer.play();
          this.style.display = 'none'; // remove overlay - not needed after first play
        }
      }
    });
  }
  
};